import React, { useState } from "react";
import { Client } from "../../interfaces/client";

interface ClientSelectorProps {
  clients: Client[];
  onSelect: (clientID: number) => void;
  onClose: () => void;
}

const ClientSelector: React.FC<ClientSelectorProps> = ({
  clients,
  onSelect,
  onClose,
}) => {
  const [selectedClientID, setSelectedClientID] = useState<number>(0);

  const handleConfirm = () => {
    if (selectedClientID !== 0) {
      onSelect(selectedClientID);
    }
  };

  return (
    <>
      <div className="background-mask" onClick={() => onClose()}></div>
      <div className="filter-popup-login">
        <div className="close-button-container">
          <button className="close-button" onClick={() => onClose()}>
            <i className="bi bi-x-circle"></i>
          </button>
        </div>
        <div className="modal-content">
          <div className="filter-header">
            <h2>Select Client</h2>
            <div>Choose the client portal you would like to view.</div>
          </div>
          <br></br>
          <select
            className="form-control"
            value={selectedClientID}
            onChange={(e) => setSelectedClientID(parseInt(e.target.value, 10))}
          >
            <option value={0} disabled>
              Select Organization
            </option>
            {clients.map((client) => (
              <option key={client.clientID} value={client.clientID}>
                {client.clientName}
              </option>
            ))}
          </select>
          <br></br>
          <div className="action-buttons">
            <button
              className={`smbtn btn-purple ${selectedClientID === 0 ? "disabled" : ""}`}
              onClick={handleConfirm}
              disabled={selectedClientID === 0}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClientSelector;
